module.exports = __webpack_public_path__ + "static/media/cookie-bite.4b95a7fc.svg";